<!-- Permissions -->
<div [appEnforcePermission]="authConfig.investigationStatusCreate" #investigationStatusCreate="appEnforcePermission">
</div>
<div [appEnforcePermission]="authConfig.investigationCommentsCreate"
  #investigationCommentsCreate="appEnforcePermission"></div>
<!-- Permissions -->
<section>
  <div class="page-filters" *ngIf="config.type !== type.investigations && loaded">
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(6,minmax(0,1fr))']">
      <kendo-gridlayout-item>
        <div class="kendo-formfield left-search-icon">
          <kendo-label [for]="search" text="Search"></kendo-label>
          <div style="position: relative;">
            <i class="fa fa-search" aria-hidden="true"></i>
            <kendo-textbox #search [value]="filterValue(filterTypes.Search)" (keydown.enter)="filterTable()"
              (valueChange)="setFilters($event, filterTypes.Search)" placeholder="Search" fillMode="outline"
              [clearButton]="false">
            </kendo-textbox>
          </div>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item>
        <app-user-select-kendo label="" [userViewFilter]="userViewFilter" placeholder="Search by staff member"
          (enteredPressed)="filterTable()" [userId]="filterValue(filterTypes.User)" [includeInactive]="false"
          (selectionChanged)="setFilters($event?.id, filterTypes.User)"></app-user-select-kendo>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item>
        <div class="kendo-formfield">
          <kendo-label [for]="Status" text="Status"></kendo-label>
          <kendo-dropdownlist #Status [data]="InvestigationStatuses | keyvalue" textField="value" valueField="value"
            fillMode="outline" [valuePrimitive]="true" [defaultItem]="{key: null, value: 'All statuses'}"
            [value]="filterValue(filterTypes.Status) || null" (keydown.enter)="enterPress(Status)"
            [popupSettings]="{appendTo: 'component', animate: false, width: 250 }" required
            (selectionChange)="setFilters($event?.value !== 'All' ? $event?.value : null , filterTypes.Status)">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span *ngIf="dataItem?.value === 'All statuses'" class="placeholder"> {{ dataItem?.value }} </span>
              <span *ngIf="dataItem?.value !== 'All statuses'" class="not-placeholder"> {{ dataItem?.value }} </span>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item>
        <div class="kendo-formfield">
          <kendo-label [for]="dropdownlist" text="Risk Type"></kendo-label>
          <kendo-dropdownlist #dropdownlist [data]="riskTypes" textField="name" valueField="name" fillMode="outline"
            [valuePrimitive]="true" [defaultItem]="{name: 'All risk types' }" [value]="filterValue(filterTypes.RiskType)"
            (keydown.enter)="enterPress(dropdownlist)"
            [popupSettings]="{appendTo: 'component', animate: false, width: 250 }"
            (selectionChange)="setFilters(($event.name !== 'All risk types') ? $event.name : null, filterTypes.RiskType)">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span *ngIf="dataItem?.name === 'All risk types'" class="placeholder"> {{ dataItem.name }} </span>
              <span *ngIf="dataItem?.name !== 'All risk types'" class="not-placeholder"> {{ dataItem.name }} </span>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item>
        <div class="kendo-formfield">
          <kendo-label [for]="Priority" text="Priority"></kendo-label>
          <kendo-dropdownlist #Priority [data]="InvestigationPriorities | keyvalue" textField="value" valueField="value"
            fillMode="outline" [valuePrimitive]="true" [defaultItem]="{key: null, value: 'All priorities'}"
            [value]="filterValue(filterTypes.Priority)" (keydown.enter)="enterPress(Priority)"
            [popupSettings]="{appendTo: 'component', animate: false, width: 250 }"
            (selectionChange)="setFilters($event?.value === 'All priorities' ? null : $event?.value, filterTypes.Priority)">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span *ngIf="dataItem?.value === 'All priorities'" class="placeholder"> {{ dataItem?.value }} </span>
              <span *ngIf="dataItem?.value !== 'All priorities'" class="not-placeholder"> {{ dataItem?.value }} </span>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item class="filter-actions" [colSpan]="1" [col]="0" [row]="0">
        <div class="applied-filter mr-16">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="filterTable()">Apply
              Filters</kendo-button>
          </div>
        </div>
        <div class="clear-filter mt-5">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="clearFilter()">Clear
              All</kendo-button>
          </div>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
    <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }" [cols]="['repeat(1,minmax(0,1fr))']">
      <kendo-gridlayout-item>
        <app-market-loss-filter [checked]="filterValue(filterTypes.MarketLoss)" (filter)="filterTable()"
          (checkedChange)="setCheckedFilters($event.checked, filterTypes.MarketLoss)"></app-market-loss-filter>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>

  <hr class="divider-line" />

  <kendo-grid class="investigation-list" [data]="{
      data: tableData,
      total: (dataSource?.pageInfo$ | async)?.totalCount
    }" [pageSize]="pageOptions?.limit" [skip]="pageOptions?.offset" [pageable]="{
      buttonCount: 6,
      type: 'numeric',
      pageSizes: [5, 10, 25, 100],
      previousNext: true,
      responsive: true,
      position: 'bottom'
    }" (pageChange)="pageChange($event)" [sortable]="true" [sort]="sort" (sortChange)="sortChange($event)"
    [navigatable]="false" [kendoGridExpandDetailsBy]="'id'" [(expandedDetailKeys)]="expandedDetailKeys">

    <kendo-grid-column field="CREATED_AT" title="Investigation" [width]="18" [sortable]="true"
      [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem" [type]="'investigation'">
        </app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="LOSS_DATE" title="Details" [width]="22" [sortable]="true" [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem" [type]="'details'">
        </app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="PRIORITY" title="Priority" [width]="8" [sortable]="true" [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem" [type]="'priority'">
        </app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="InvestigationStaff" title="Assigned" [width]="16" [sortable]="false"
      [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem?.InvestigationStaff?.length > 0; else assignedEmptyState">
          <div class="merged-column-cell assigned-cell">
            <div class="assigned-row" *ngFor="let staff of orderInvestigationStaff(dataItem?.InvestigationStaff)">
              <span class="assigned-name">{{ staff.User | fullName }}</span>
              <span class="assigned-icons">
                <i class="fa-solid fa-calendar-days cursor-pointer" kendoTooltip position="bottom"
                  title="Event Scheduled" tooltipClass="tooltipwidthauto" *ngIf="staff?.CurrFutureEvents"
                  (click)="$event.stopPropagation(); openStaffSidebar(dataItem)"></i>
                <app-svg-icon name="book-blank" [size]="14" variant="success" *ngIf="staff?.UnBilled" kendoTooltip
                  position="bottom" title="Billable Hours" tooltipClass="tooltipwidthauto" class="cursor-pointer"
                  (click)="$event.stopPropagation(); onAssignedAction({ text: 'Add Time & Expense' }, dataItem)"></app-svg-icon>
                <i class="fa-solid fa-image color-dark-blue cursor-pointer" *ngIf="staff?.PhotosUploaded" kendoTooltip
                  position="bottom" title="Photos Uploaded" tooltipClass="tooltipwidthauto"
                  (click)="$event.stopPropagation(); onAssignedAction({ text: 'Upload Photos' }, dataItem)"></i>
              </span>
            </div>
          </div>
        </ng-container>
        <ng-template #assignedEmptyState>-</ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="investigationIcons" title="Current" [width]="14" [sortable]="false"
      [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem" [type]="'current'"
          [investigationCommentsCreateEnabled]="investigationCommentsCreate?.enabled"
          (commentAdd)="addComment($event)"
          (documentsReportsOpen)="goToInvestigationDocumentsReports($event.event, $event.investigation)">
        </app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="id" title="Action" [width]="10" [sortable]="false" [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton class="mr-8" themeColor="primary" fillMode="link" iconClass="fa-solid fa-copy"
          (click)="copyToClipboard(dataItem)"></button>
        <kendo-dropdownbutton [data]="assignedActionItems" themeColor="primary" fillMode="link"
          buttonClass="grid-action-items" iconClass="fa-solid fa-ellipsis"
          (itemClick)="onAssignedAction($event, dataItem)" [popupSettings]="{
                                  appendTo: 'component',
                                  animate: false,
                                  width: 250,
                                  popupClass: 'grid-action-items-menu'
                                }">
        </kendo-dropdownbutton>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="displayComments">
      <kendo-grid [data]="dataItem?.Comments.slice(0, 5)" [pageable]="false" [scrollable]="'none'"
        [className]="'detail-items'">
        <kendo-grid-column field="createdAt" title="Date/Time" [width]="30" [sortable]="false"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span style="text-transform: lowercase">
              {{ dataItem?.createdAt | customDate : "MM/dd/yy, h:mma" }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="text" title="Comment" [width]="120" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="text-overflow">{{ dataItem?.text }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="CreatedBy" title="User" [width]="50" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.CreatedBy | fullName }}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
      <p class="mt-24 mb-24">There are no results to display.</p>
    </ng-template>
  </kendo-grid>
</section>
